module.exports = __webpack_public_path__ + "/build/web/images/hero-article@2x.a0f0c994afb9c283bb87d1f8d3e841e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-article@2x.jpg
// module id = 137
// module chunks = 13